(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('biaProfileFollowUp', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/BCM/BIAProfile/biaProfileFollowUp.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BCMManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    $controller('BoxTmplController', { $scope: $scope });
                }
            ],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        };
    }
})();